import React from 'react';
import ProgressiveImage from 'react-progressive-graceful-image';
import cx from 'classnames';
import './Background.css';

function Background({ src, placeholder, delay, className, children, ...otherProps }) {
  return (
    <ProgressiveImage src={src} placeholder={placeholder} delay={delay}>
      {
        (src, loading) => (
          <div className={cx("ha-background", className)} {...otherProps}>
            <div className={cx("ha-background-wrapper", "original", 'origin100')} style={{ backgroundImage: `url(${src})` }} />
            <div className={cx("ha-background-wrapper", "thumb", 'origin100', { hide: !loading })} style={{ backgroundImage: `url(${src})` }} />
            <div className="ha-background-content">
              {children}
            </div>
          </div>
        )
      }
    </ProgressiveImage>
  )
}

export default Background;
